import { connect } from 'react-redux';
import UsageSummaryPane from '../../components/usage/UsageSummaryPane';
import {
  getUsageAvgSessionLength,
  getUsageSessions,
  getUsageUniqueUsers,
  isUsageExecuting,
} from '../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  executing: isUsageExecuting(state),
  sessions: getUsageSessions(state),
  avgSessionLength: getUsageAvgSessionLength(state),
  uniqueUsers: getUsageUniqueUsers(state),
});

export default connect(mapStateToProps)(UsageSummaryPane);
